import React from 'react';
import { motion } from 'framer-motion';
import { Search, Sparkles, Handshake, Calendar, X } from 'lucide-react';
const threads = [{
  sender: 'The Empty Bottle',
  subject: 'Re: June dates available',
  time: '2h ago',
  unread: true,
  campaign: 'Summer Run'
}, {
  sender: 'Higher Ground',
  subject: 'Interested in June 18th',
  time: '5h ago',
  unread: true,
  campaign: 'Summer Run'
}, {
  sender: 'Beachland Tavern',
  subject: 'Contract ready for review',
  time: '1d ago',
  unread: false,
  campaign: 'Summer Run'
}, {
  sender: 'The Sinclair',
  subject: 'Checking availability',
  time: '2d ago',
  unread: false,
  campaign: 'Summer Run'
}, {
  sender: 'Club Passim',
  subject: 'Not available in June',
  time: '3d ago',
  unread: false,
  campaign: 'Summer Run'
}, {
  sender: 'ArtsRiot',
  subject: 'Following up on your inquiry',
  time: '4d ago',
  unread: false,
  campaign: 'Summer Run'
}];
export function InboxPage() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="h-[calc(100vh-8rem)] flex gap-6" data-id="element-3605">
      {/* Left Pane - Filters */}
      <div className="w-48 shrink-0 flex flex-col gap-1" data-id="element-3606">
        <button className="w-full text-left px-3 py-2 rounded-lg bg-surfaceHover text-textMain font-medium text-sm flex justify-between items-center" data-id="element-3607">
          All Messages
        </button>
        <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm flex justify-between items-center" data-id="element-3608">
          Unread
          <span className="bg-primary text-background text-[10px] font-bold px-1.5 py-0.5 rounded-full" data-id="element-3609">
            3
          </span>
        </button>
        <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm flex justify-between items-center" data-id="element-3610">
          Needs Response
          <span className="bg-amber-500 text-background text-[10px] font-bold px-1.5 py-0.5 rounded-full" data-id="element-3611">
            2
          </span>
        </button>
        <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm flex justify-between items-center" data-id="element-3612">
          Interested
          <span className="bg-surface border border-border text-textMuted text-[10px] font-bold px-1.5 py-0.5 rounded-full" data-id="element-3613">
            4
          </span>
        </button>

        <div className="mt-6 mb-2 px-3 text-xs font-semibold text-textMuted uppercase tracking-wider" data-id="element-3614">
          By Campaign
        </div>
        <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm truncate" data-id="element-3615">
          Summer Run '26
        </button>
        <button className="w-full text-left px-3 py-2 rounded-lg text-textMuted hover:bg-surface hover:text-textMain transition-colors text-sm truncate" data-id="element-3616">
          Fall Northeast
        </button>
      </div>

      {/* Center Pane - Thread List */}
      <div className="w-[350px] shrink-0 flex flex-col bg-surface border border-border rounded-xl overflow-hidden" data-id="element-3617">
        <div className="p-3 border-b border-border" data-id="element-3618">
          <div className="relative" data-id="element-3619">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-textMuted" data-id="element-3620" />
            <input type="text" placeholder="Search inbox..." className="w-full pl-9 pr-4 py-1.5 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-3621" />
          </div>
        </div>
        <div className="flex-1 overflow-y-auto" data-id="element-3622">
          {threads.map((thread, i) => <div key={i} className={`p-4 border-b border-border cursor-pointer transition-colors ${i === 0 ? 'bg-primary/5 border-l-2 border-l-primary' : 'hover:bg-surfaceHover border-l-2 border-l-transparent'}`} data-id="element-3623">
              <div className="flex justify-between items-start mb-1" data-id="element-3624">
                <span className={`text-sm ${thread.unread ? 'font-bold text-textMain' : 'font-medium text-textMuted'}`} data-id="element-3625">
                  {thread.sender}
                </span>
                <span className="text-xs text-textMuted" data-id="element-3626">{thread.time}</span>
              </div>
              <div className={`text-sm mb-2 truncate ${thread.unread ? 'font-medium text-textMain' : 'text-textMuted'}`} data-id="element-3627">
                {thread.subject}
              </div>
              <div className="flex items-center justify-between" data-id="element-3628">
                <span className="px-2 py-0.5 bg-background border border-border rounded text-[10px] text-textMuted" data-id="element-3629">
                  {thread.campaign}
                </span>
                {thread.unread && <div className="w-2 h-2 rounded-full bg-primary" data-id="element-3630"></div>}
              </div>
            </div>)}
        </div>
      </div>

      {/* Right Pane - Thread Detail */}
      <div className="flex-1 flex flex-col bg-surface border border-border rounded-xl overflow-hidden" data-id="element-3631">
        {/* Header */}
        <div className="p-4 border-b border-border flex justify-between items-start bg-background/50" data-id="element-3632">
          <div data-id="element-3633">
            <h2 className="text-lg font-semibold mb-1" data-id="element-3634">
              Re: June dates available
            </h2>
            <div className="text-sm text-textMuted" data-id="element-3635">
              The Empty Bottle • booking@emptybottle.com
            </div>
          </div>
          <div className="flex gap-2" data-id="element-3636">
            <button className="px-3 py-1.5 bg-primary text-background text-sm font-medium rounded-lg hover:bg-primaryHover transition-colors flex items-center gap-1.5" data-id="element-3637">
              <Handshake className="w-4 h-4" data-id="element-3638" /> Create Deal
            </button>
            <button className="px-3 py-1.5 bg-surface border border-border text-sm font-medium rounded-lg hover:bg-surfaceHover transition-colors flex items-center gap-1.5" data-id="element-3639">
              <Calendar className="w-4 h-4" data-id="element-3640" /> Propose Date
            </button>
            <button className="p-1.5 bg-surface border border-border rounded-lg hover:bg-surfaceHover transition-colors text-textMuted hover:text-red-500" data-id="element-3641">
              <X className="w-4 h-4" data-id="element-3642" />
            </button>
          </div>
        </div>

        {/* AI Banner */}
        <div className="px-4 py-3 bg-primary/10 border-b border-primary/20 flex items-start gap-3" data-id="element-3643">
          <Sparkles className="w-5 h-5 text-primary shrink-0 mt-0.5" data-id="element-3644" />
          <div data-id="element-3645">
            <div className="text-sm font-medium text-primary mb-1" data-id="element-3646">
              Suggested Action
            </div>
            <div className="text-sm text-textMuted mb-2" data-id="element-3647">
              They are offering $1,500 for June 12th. This is below your $2,000
              target fee.
            </div>
            <div className="flex gap-2" data-id="element-3648">
              <button className="px-2 py-1 bg-surface border border-primary/30 text-primary text-xs rounded hover:bg-primary/20 transition-colors" data-id="element-3649">
                Draft counter-offer ($2,000)
              </button>
              <button className="px-2 py-1 bg-surface border border-border text-textMuted text-xs rounded hover:text-textMain transition-colors" data-id="element-3650">
                Accept offer
              </button>
            </div>
          </div>
        </div>

        {/* Messages */}
        <div className="flex-1 overflow-y-auto p-6 space-y-6" data-id="element-3651">
          <div className="flex gap-4" data-id="element-3652">
            <div className="w-8 h-8 rounded-full bg-surface border border-border flex items-center justify-center text-sm font-bold shrink-0" data-id="element-3653">
              EB
            </div>
            <div className="flex-1" data-id="element-3654">
              <div className="flex justify-between items-baseline mb-2" data-id="element-3655">
                <span className="font-medium" data-id="element-3656">The Empty Bottle</span>
                <span className="text-xs text-textMuted" data-id="element-3657">Today, 10:24 AM</span>
              </div>
              <div className="text-sm text-textMuted leading-relaxed space-y-4" data-id="element-3658">
                <p data-id="element-3659">Hey Mark,</p>
                <p data-id="element-3660">
                  Thanks for reaching out. We'd love to have The Wildwoods back.
                  June 12th is currently open on our calendar.
                </p>
                <p data-id="element-3661">
                  We can offer a $1,500 guarantee vs 70% of door after expenses.
                  Let me know if that works for you and I'll send over the hold
                  details.
                </p>
                <p data-id="element-3662">
                  Best,
                  <br data-id="element-3663" />
                  Dan
                </p>
              </div>
            </div>
          </div>

          <div className="flex gap-4 opacity-60" data-id="element-3664">
            <div className="w-8 h-8 rounded-full bg-primary/20 border border-primary/30 flex items-center justify-center text-sm font-bold text-primary shrink-0" data-id="element-3665">
              M
            </div>
            <div className="flex-1" data-id="element-3666">
              <div className="flex justify-between items-baseline mb-2" data-id="element-3667">
                <span className="font-medium" data-id="element-3668">You</span>
                <span className="text-xs text-textMuted" data-id="element-3669">
                  Yesterday, 2:15 PM
                </span>
              </div>
              <div className="text-sm text-textMuted leading-relaxed" data-id="element-3670">
                <p data-id="element-3671">Hi Dan,</p>
                <p data-id="element-3672">
                  The Wildwoods are routing through Chicago mid-June. We're
                  looking at June 12th or 13th. Are either of those dates open?
                </p>
                <p data-id="element-3673">Mark</p>
              </div>
            </div>
          </div>
        </div>

        {/* Reply Box */}
        <div className="p-4 border-t border-border bg-background/50" data-id="element-3674">
          <div className="bg-surface border border-border rounded-lg p-3" data-id="element-3675">
            <textarea placeholder="Reply to The Empty Bottle..." className="w-full bg-transparent text-sm focus:outline-none resize-none h-20 text-textMain placeholder:text-textMuted" data-id="element-3676"></textarea>
            <div className="flex justify-between items-center mt-2 pt-2 border-t border-border" data-id="element-3677">
              <button className="text-xs text-primary hover:text-primaryHover flex items-center gap-1" data-id="element-3678">
                <Sparkles className="w-3 h-3" data-id="element-3679" /> Draft with AI
              </button>
              <button className="px-4 py-1.5 bg-textMain text-background text-sm font-medium rounded hover:bg-textMuted transition-colors" data-id="element-3680">
                Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}